type TErrorsTranslations = {
  [key: string]: string
}


type TErrorPageTranslations = {
  [language: string] : TErrorsTranslations
}


const errorPageTranslations: TErrorPageTranslations = {
  'ca': {
    'mybank:errorpage:ups': 'Uppsss…',
    'mybank:errorpage:errormsg:fatal': 'Sembla que alguna cosa ha fallat en els nostres sistemes i la pàgina no està funcionant com hauria',
    'mybank:errorpage:errormsg': 'Ho sentim, no trobem la pàgina, però tranquil@ que els teus estalvis no paren de pujar',
    'mybank:errorpage:errormsg2': 'Si tens qualsevol dubte, contacta amb un dels nostres gestors al telèfon:',
    'mybank:errorpage:errortlf': '+376 881 960',
    'mybank:errorpage:back-hometext': 'Tornar a la home',
  },
  'es': {
    'mybank:errorpage:ups': 'Uppsss…',
    'mybank:errorpage:errormsg:fatal': 'Parece que algo ha fallado en nuestros sistemas y la página no está funcionando como debería',
    'mybank:errorpage:errormsg': 'Lo sentimos, no encontramos la página, pero tranquil@ que tus ahorros no paran de subir',
    'mybank:errorpage:errormsg2': 'Si tienes cualquier duda, contacta con uno de nuestros gestores en el teléfono:',
    'mybank:errorpage:errortlf': '+376 881 960',
    'mybank:errorpage:back-hometext': 'Volver a la home',
  },
  'en': {
    'mybank:errorpage:ups': 'Oops...',
    'mybank:errorpage:errormsg:fatal': 'It seems something has failed in our systems and the page is not working as it should',
    'mybank:errorpage:errormsg': 'Sorry, we cannot find the page, but don\'t worry, your savings keep growing',
    'mybank:errorpage:errormsg2': 'If you have any questions, contact one of our managers at:',
    'mybank:errorpage:errortlf': '+376 881 960',
    'mybank:errorpage:back-hometext': 'Back to home',
  },
  'fr': {
    'mybank:errorpage:ups': 'Oups...',
    'mybank:errorpage:errormsg:fatal': 'Il semble que quelque chose a échoué dans nos systèmes et la page ne fonctionne pas comme elle le devrait',
    'mybank:errorpage:errormsg': 'Désolé, nous ne trouvons pas la page, mais ne vous inquiétez pas, vos économies continuent d\'augmenter',
    'mybank:errorpage:errormsg2': 'Si vous avez des questions, contactez l\'un de nos gestionnaires au:',
    'mybank:errorpage:errortlf': '+376 881 960',
    'mybank:errorpage:back-hometext': 'Retour à l\'accueil',
  }
}

export default errorPageTranslations;